var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('organization-load-guard',{attrs:{"organization-id":_vm.organizationId}},[_c('organization-packet-creator-library',{attrs:{"peer-group-id":_vm.peerGroupId}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }